import {
  Paper,
  Typography,
  Button,
  TableContainer,
  CircularProgress,
} from "@mui/material";
import {  MouseEvent } from "react";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import TableComponent from "../../component/TableComponent";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import useRepotFile from "../../hooks/reportFileHook";
import { getCptwiseReport, getCptwiseReportPdf } from "../services";

function CptGroupwiseReport() {
  const { control, reset, getValues } = useForm();
  const {
    mutate: getDailyInvoiceReport,
    data: cptGroupwiseData,
    isLoading: reportLoading,
    reset: resetMutation,
  } = useMutation(getCptwiseReport);

  const { mutate: getDailyRevenueReportPdf, isLoading: pdfLoading } =
    useRepotFile({
      apiFunction: getCptwiseReportPdf,
    });
  //   const { mutate: getDailyRevenueReportExcel, isLoading: excelLoading } =
  //     useRepotFile({
  //       apiFunction: async()=>new Promise(),
  //       fileType: "xls",
  //       responseFileKey: "file",
  //     });

  const onChange = () => {
    const data = getValues();
    if (data.fromDate && data?.toDate) {
      getDailyInvoiceReport(data as { fromDate: string; toDate: string });
    }else{
      resetMutation()
    }
  };

  const clearForm = () => {
    reset({
      fromDate: "",
      toDate: "",
    });
    resetMutation();
  };

  const getFiles = (e: MouseEvent<HTMLButtonElement>) => {
    const fileType = e.currentTarget.dataset.filetype;
    const allData = getValues();
    if (fileType === "pdf") {
      getDailyRevenueReportPdf({
        fromDate: allData.fromDate,
        toDate: allData.toDate,
      });
    }
    // else {
    //   getDailyRevenueReportExcel({
    //     fromDate: allData.fromDate,
    //     toDate: allData.toDate,
    //   });
    // }
  };

  return (
    <div className="px-3 py-4 flex flex-col gap-3">
      <Paper>
        <div className="p-4 border-b">
          <Typography color={"primary"} fontWeight={600} fontSize={"1rem"}>
            CPT Group Wise Billing Report
          </Typography>
        </div>
        <form
          // onSubmit={handleSubmit(onSubmit)}
          className="grid grid-cols-2 gap-3 p-4"
        >
          <CustomFormField
            control={control}
            element="datepicker"
            name="fromDate"
            fieldProps={{ label: "From Date" }}
            rules={{ required: "From Date is required", onChange }}
          />
          <CustomFormField
            control={control}
            element="datepicker"
            name="toDate"
            fieldProps={{ label: "To Date" }}
            rules={{ required: "TO Date is required", onChange }}
          />
          <div className="col-span-full flex justify-end items-center gap-3">
            {/* <Button
            type="submit"
            disabled={reportLoading}
            endIcon={reportLoading && <CircularProgress size={18} />}
          >
            search
          </Button> */}
            <Button color="error" onClick={clearForm}>
              clear
            </Button>
          </div>
        </form>
      </Paper>

      <TableContainer component={Paper}>
        <div className="flex justify-end gap-3 py-2 px-4 border-b">
          <Button
            disabled={
              pdfLoading || !Boolean(cptGroupwiseData?.response?.length)
            }
            endIcon={pdfLoading && <CircularProgress size={18} />}
            data-filetype="pdf"
            onClick={getFiles}
          >
            pdf
          </Button>
          {/* <Button
          disabled={excelLoading || !Boolean(cptGroupwiseData?.response?.length)}
          endIcon={excelLoading && <CircularProgress size={18} />}
          data-filetype="excel"
          onClick={getFiles}
        >
          excel
        </Button> */}
        </div>
        <TableComponent
          loading={reportLoading}
          data={cptGroupwiseData?.response || []}
          tableProps={heading}
        />
      </TableContainer>
    </div>
  );
}

export default CptGroupwiseReport;

const heading = [
  { heading: "Group", key: "cptGroupName" },
  { heading: "Amount", key: "amount" },
];
